/** Tag text for what a package was built from, keyed by the API's `source_type` (the packaging
 *  job's SourceType values). */
const SOURCE_TYPE_LABELS: Record<string, string> = {
  winget: 'WinGet',
  chocolatey: 'Chocolatey',
  file_upload: 'Installer',
  url: 'URL',
}

type Sourced = { source_type?: string | null; source_reference?: string | null }

/** The tag for a package, or null when the record does not say what it was built from. */
export function sourceTypeLabel(app: Sourced): string | null {
  return (app.source_type && SOURCE_TYPE_LABELS[app.source_type]) || null
}

/** Tooltip naming the package the entry was built from, e.g. `WinGet: Microsoft.VisualStudioCode`. */
export function sourceTypeTitle(app: Sourced): string | undefined {
  const label = sourceTypeLabel(app)
  if (!label) return undefined
  if (app.source_type === 'winget' || app.source_type === 'chocolatey') {
    return app.source_reference ? `${label}: ${app.source_reference}` : `Built from ${label}`
  }
  return app.source_type === 'url' ? 'Built from an installer URL' : 'Built from an uploaded installer'
}
